import icones from "../components/utils/icones/Index";

const values = {};

icones.forEach(icone => {
  if (icone.path) {
    values[icone.name] = icone.path;
  } else {
    values[icone.name] = {
      component: icone,
    };
  }
})

export default { values }
